<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleList">
            <el-tab-pane label="采购选品列表" name="first">
                <purchasingOptionsList v-if="activeName == 'first'" :managerAnalysisList="managerAnalysisList"
                                       ref="purchasingOptionsList"/>
            </el-tab-pane>
            <el-tab-pane label="采购中列表" name="second">
                <transferInPurchase v-if="activeName == 'second'" :managerAnalysisList="managerAnalysisList"
                                    ref="transferInPurchase"/>
            </el-tab-pane>
            <el-tab-pane label="运营选品列表" name="third">
                <transferSelectionOperation v-if="activeName == 'third'" :managerAnalysisList="operatorList"
                                    ref="transferSelectionOperation"/>
            </el-tab-pane>
            <el-tab-pane label="运营中列表" name="fourth">
                <transferActiveList v-if="activeName == 'fourth'" :managerAnalysisList="operatorList"
                                    ref="transferActiveList"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import purchasingOptionsList from './component/purchasingOptionsList'
    import transferInPurchase from './component/transferInPurchase'
    import transferSelectionOperation from './component/transferSelectionOperation'
    import transferActiveList from './component/transferActiveList'

    export default {
        name: 'accountTransfer',
        components: {
            purchasingOptionsList,
            transferSelectionOperation,
            transferActiveList,
            transferInPurchase
        },
        data() {
            return {
                activeName: 'first',
                managerAnalysisList: [],
                operatorList: [],
            }
        },
        mounted() {
            this.developerList()
        },
        methods: {
            developerList() {
                Promise.all([api.manager_index_get_developer_list(), api.manager_index_get_operator_list()]).then(arr=>{
                    this.loading = false

                    const res = arr[0]
                    if (res.code === 0) {
                        const responseList = (res.data || {}).map((item, key) => {
                            return {id: item.id, full_name: item.full_name + '-' + item.username}
                        })
                        this.managerAnalysisList = responseList
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }

                    const res1 = arr[1]
                    if (res1.code === 0) {
                        const responseList = res1.data || []
                        this.operatorList = responseList
                    } else {
                        this.$message({
                            type: 'error',
                            message: res1.message
                        })
                    }

                    this.handleList()

                })
            },
            handleList() {
                let tempRef = ''
                let arr = this.managerAnalysisList
                switch (this.activeName) {
                    case 'first':
                        tempRef = 'purchasingOptionsList'
                        break
                    case 'second':
                        tempRef = 'transferInPurchase'
                        break
                    case 'third':
                        tempRef = 'transferSelectionOperation'
                        arr = this.operatorList
                        break
                    case 'fourth':
                        tempRef = 'transferActiveList'
                        arr = this.operatorList
                        break
                }
                this.$nextTick(()=>{
                    this.$refs[tempRef].getList(arr)
                })
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
